import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
export function Breadcrumbs({
  items,
  dark = false
}: {
  items: {
    label: string;
    path: string;
  }[];
  dark?: boolean;
}) {
  return <nav aria-label="Breadcrumb" className={`text-[13px] ${dark ? 'text-steel-light' : 'text-steel'}`} data-id="element-113" data-mp="4o0jgugg208n">
    <ol className="flex flex-wrap items-center gap-x-2 gap-y-1" data-id="element-114" data-mp="9n3b9d7ey9yo">
      {items.map((item, index) => <li key={item.path} className="flex items-center gap-2" data-id="element-115" data-mp="384quxousp5hq" data-mpi={index}>
        {index > 0 && <ChevronRightIcon aria-hidden="true" className="h-3 w-3 shrink-0" data-id="element-116" data-mp="382mgicz9so37" />}
        {index === items.length - 1 ? <span aria-current="page" data-id="element-117" data-mp="3d1pj7qrs2i80">{item.label}</span> : <a href={item.path} className={`underline-offset-4 hover:underline ${dark ? 'hover:text-paper' : 'hover:text-ink'}`} data-id="element-118" data-mp="3i1vh3oon50yj">{item.label}</a>}
      </li>)}
    </ol>
  </nav>;
}